@if (
  {
    loanInfo: loanInfo$ | async,
    combinedHousingExpenses: combinedHousingExpenses$ | async,
    cashToClose: cashToClose$ | async,
  };
  as vm
) {
  <div class="row mb-3">
    <div class="col">
      <p-panel class="secondary-panel">
        <ng-template pTemplate="header">Underwriting Information</ng-template>
        <cmg-info-panel-content>
          <div class="row">
            <div class="col-12 col-md-6 border-md-end">
              <cmg-info-row label="Underwriter Name" [value]="loan1008Data?.underwritterName | emptyToDash" />
            </div>
            <div class="col-12 col-md-6 ps-md-4">
              <cmg-info-row label="Appraiser's Name" [value]="loan1008Data?.appraiser.partyName | emptyToDash" />
            </div>
            <div class="col-12 col-md-6 border-md-end">
              <cmg-info-row label="Appraiser's License #" [value]="loan1008Data?.appraiser.licenseNo | emptyToDash" />
            </div>
            <div class="col-12 col-md-6 ps-md-4">
              <cmg-info-row label="Appraisal Company Name" [value]="loan1008Data?.appraiser.company | emptyToDash" />
            </div>
          </div>
        </cmg-info-panel-content>
      </p-panel>
    </div>
  </div>

  <div class="row mb-3">
    <div class="col">
      <p-panel class="secondary-panel">
        <ng-template pTemplate="header">Additional Property Information</ng-template>
        @if (vm.loanInfo) {
          <cmg-info-panel-content>
            <div class="row">
              <div class="col-12 col-md-6 border-md-end">
                <cmg-info-row label="Borrower Total Income" [value]="loan1008Data?.transmittal.totalIncomeBorOV | currency | emptyToDash" />
              </div>
              <div class="col-12 col-md-6 ps-md-4">
                <cmg-info-row label="CLTV/TLTV" [value]="vm.loanInfo?.cltv / 100 | percent: '1.3-3' | emptyToDash" />
              </div>
              <div class="col-12 col-md-6 border-md-end">
                <cmg-info-row
                  label="Additional Borrower Total Income"
                  [value]="loan1008Data?.transmittal.totalIncomeCoBorsOV | currency | emptyToDash"
                />
              </div>
              <div class="col-12 col-md-6 ps-md-4">
                <cmg-info-row label="HCLTV/HTLTV" [value]="vm.loanInfo?.subOrdinateFinance?.hcltv / 100 | percent: '1.3-3' | emptyToDash" />
              </div>
              <div class="col-12 col-md-6 border-md-end">
                <cmg-info-row label="Total Income" [value]="loan1008Data?.transmittal.totalIncomeTotalOV | currency | emptyToDash" />
              </div>
              <div class="col-12 col-md-6 ps-md-4">
                <cmg-info-row label="LTV" [value]="vm.loanInfo?.ltv / 100 | percent: '1.3-3' | emptyToDash" />
              </div>
            </div>
          </cmg-info-panel-content>
        }
      </p-panel>
    </div>
  </div>

  <div class="row mb-3">
    <div class="col">
      <p-panel class="secondary-panel">
        <ng-template pTemplate="header">Qualifying Ratios</ng-template>
        @if (vm.loanInfo) {
          <cmg-info-panel-content>
            <div class="row">
              <div class="col-12 col-md-6 border-md-end">
                <cmg-info-row label="Housing Expenses/Income" [value]="vm.loanInfo?.firstRatio / 100 | percent: '1.3-3' | emptyToDash" />
              </div>
              <div class="col-12 col-md-6 ps-md-4">
                <cmg-info-row label="Total Obligations/Income" [value]="vm.loanInfo?.secondRatio / 100 | percent: '1.3-3' | emptyToDash" />
              </div>
              <div class="col-12 col-md-6 border-md-end">
                <cmg-info-row label="Debit to Housing Gap Ratio" [value]="vm.loanInfo?.gapRatio / 100 | percent: '1.3-3' | emptyToDash" />
              </div>
            </div>
          </cmg-info-panel-content>
        }
        <div class="mt-3">
          <hr />
        </div>
        <div class="row my-2">
          <div class="col px-1">
            <div class="d-flex d-md-inline-flex pe-3 my-2">
              <input type="radio" name="qualRatios" id="noteRate" disabled [checked]="loan1008Data?.noteRate" class="mt-0 me-2" />
              <label for="noteRate" class="mb-0">Note Rate</label>
            </div>
            <div class="d-flex d-md-inline-flex pe-3 my-2">
              <input type="radio" name="qualRatios" id="aboveNoteRate" disabled [checked]="loan1008Data?.aboveNoteRate" class="mt-0 me-2" />
              <label for="aboveNoteRate" class="mb-0">Above Note Rate</label>
            </div>
            <div class="d-flex d-md-inline-flex pe-3 my-2">
              <input type="radio" name="qualRatios" id="belowNoteRate" disabled [checked]="loan1008Data?.belowNoteRate" class="mt-0 me-2" />
              <label for="belowNoteRate" class="mb-0">% Below Note Rate</label>
            </div>
            <div class="d-flex d-md-inline-flex pe-3 my-2">
              <input type="radio" name="qualRatios" id="downNoteRate" disabled [checked]="loan1008Data?.boughtDownRate" class="mt-0 me-2" />
              <label for="downNoteRate" class="mb-0">Bought Down Note Rate</label>
            </div>
            <div class="d-flex d-md-inline-flex pe-3 my-2">
              <input type="radio" name="qualRatios" id="other" disabled [checked]="loan1008Data?.other" class="mt-0 me-2" />
              <label for="other" class="mb-0">Other</label>
            </div>
          </div>
        </div>
      </p-panel>
    </div>
  </div>

  <div class="pt-4">
    <div class="row">
      <div class="col-12 col-md-6">
        <p-panel class="secondary-panel">
          <ng-template pTemplate="header">Housing Payment</ng-template>

          <cmg-info-panel-content>
            @if (vm.combinedHousingExpenses) {
              <cmg-info-row label="Present Housing Payments" [value]="vm.combinedHousingExpenses?.total?.presentAmount | currency | emptyToDash" />
            }

            <span class="lead fw-bold fs-5 py-3 d-block">Proposed Monthly Payments</span>
            @if (vm.loanInfo) {
              <cmg-info-row
                label="First Mortgage P&I"
                [value]="vm.loanInfo?.loanInfoCombinedHousingExpense?.firstMortgageProposed | currency | emptyToDash"
              />
              <cmg-info-row label="Second Mortgage P&I" [value]="loan1008Data?.transmittal.primaryResSecondMortPIOV | currency | emptyToDash" />
              <cmg-info-row label="Hazard Insurance" [value]="loan1008Data?.transmittal.primaryResHazOV | currency | emptyToDash" />
              <cmg-info-row label="Taxes" [value]="loan1008Data?.transmittal.primaryResPropTaxesOV | currency | emptyToDash" />
              <cmg-info-row label="Mortgage Insurance" [value]="loan1008Data?.transmittal.primaryResMIOV | currency | emptyToDash" />
              <cmg-info-row label="HOA Fees" [value]="loan1008Data?.transmittal.primaryResHODOV | currency | emptyToDash" />
              <cmg-info-row label="Lease/Ground Rent" [value]="loan1008Data?.transmittal.primaryResLeaseOV | currency | emptyToDash" />
              <cmg-info-row label="Other" [value]="vm.loanInfo?.loanInfoCombinedHousingExpense?.otherProposed | currency | emptyToDash" />
              <cmg-info-row
                label="Total Housing expenses"
                [value]="vm.loanInfo?.loanInfoCombinedHousingExpense?.proposedTotal | currency | emptyToDash"
              />
            }

            <span class="lead fw-bold fs-5 py-3 d-block">Other Obligations</span>
            @if (vm.loanInfo) {
              <cmg-info-row label="All other Monthly Payments" [value]="vm.loanInfo?.totalMonthlyPayments | currency | emptyToDash" />
              <cmg-info-row
                label="Total All Monthly"
                [value]="vm.loanInfo?.loanInfoCombinedHousingExpense?.proposedTotal + vm.loanInfo?.totalMonthlyPayments | currency | emptyToDash"
              />
            }
            <div class="mt-3">
              <hr />
            </div>
            <cmg-info-row
              label="Level of Property Review"
              [value]="loan1008Data?.transmittal.appraisalType ? getMatchString(loan1008Data?.transmittal.appraisalType) : '-'"
            />
            <cmg-info-row label="Form #" [value]="loan1008Data?.transmittal.appraisalFormNo | emptyToDash" />
          </cmg-info-panel-content>
        </p-panel>
      </div>

      <div class="col-12 col-md-6">
        <p-panel class="secondary-panel">
          <ng-template pTemplate="header">Risk Assessment</ng-template>
          <cmg-info-panel-content>
            <cmg-info-row
              label="Underwriting Method"
              [value]="loan1008Data?.transmittal.riskAssessmentMethod ? getMatchString(loan1008Data?.transmittal.riskAssessmentMethod) : '-'"
            />
            <cmg-info-row label="LP Doc Class (Freddie)" [value]="loan1008Data?.transmittal.documentClassification | emptyToDash" />
            <cmg-info-row label="Other" [value]="loan1008Data?.transmittal.riskAssessmentMethodOther | emptyToDash" />
            <cmg-info-row label="Representative Credit/Indicator Score" [value]="loan1008Data?.transmittal.repCreditScore | emptyToDash" />
            <cmg-info-row label="AUS Recommendation" [value]="loan1008Data?.transmittal.ausRecommendation | emptyToDash" />
            <cmg-info-row label="Escrow Waiver" [value]="fileData?.waiveEscrow | toNameOrValueNoSelect: escrowWaiverType : 'name'" />
            <cmg-info-row label="DU Case ID / LP AUS Key#" [value]="loan1008Data?.transmittal.ausFileID | emptyToDash" />
            <cmg-info-row label="Underwriter Comments" [value]="loan1008Data?.transmittal.uwCom | emptyToDash" />

            <span class="lead fw-bold fs-5 py-3 d-block">Borrower Funds to Close</span>
            @if (vm.cashToClose) {
              <cmg-info-row label="Required" [value]="vm.cashToClose | currency | emptyToDash" />
            }
            <cmg-info-row label="Source of Funds" [value]="fileData?.downPaymentDescOV | emptyToDash" />
            <cmg-info-row
              label="Interested Party Contributions"
              [value]="loan1008Data?.transmittal.interestedPartyContributions | currency | emptyToDash"
            />
            <cmg-info-row
              label="Home Ownership Education"
              [value]="fileData?.homeBuyerEducation === 0 ? '-' : fileData?.homeBuyerEducation === 1 ? 'Yes' : 'No'"
            />
            <cmg-info-row label="Community Lending" [value]="getMatchString(fileData?.communityLending)" />
            <cmg-info-row label="Verified Assets" [value]="fileData?.totalAllLiquidAssets | currency | emptyToDash" />
            <cmg-info-row
              label="No. of Months Reserves"
              [value]="loan1008Data?.transmittal.monthsInReserveOV ? loan1008Data?.transmittal.monthsInReserveOV : 0"
            />
          </cmg-info-panel-content>
        </p-panel>
      </div>
    </div>
  </div>
}
